import { render } from "./NavView.vue?vue&type=template&id=650a1f92"
import script from "./NavView.vue?vue&type=script&lang=js"
export * from "./NavView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__